import React from 'react'
import { initializeApollo } from 'gql/client'
import { PAGINA } from 'utils/queries'
import RegistrazioneTemplate from '@components/templates/RegistrazioneTemplate/RegistrazioneTemplate'
import { NextWrapper } from 'data-fetching-wrapper'

const RegistrazionePage = ({ pagina }) => <RegistrazioneTemplate pagina={pagina} />

export const getStaticProps = NextWrapper.getStaticProps(async () => {
  const client = initializeApollo()

  const {
    data: { pagina },
  } = await client.query({
    query: PAGINA,
    variables: { chiave: 'registrazione' },
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  return {
    props: { pagina },
    revalidate: 60 * 2,
  }
}, '/registrazione')

export default RegistrazionePage
